import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './_guards/auth.guard';

const routes: Routes = [
	{ path: '', component: HomeComponent, canActivate: [AuthGuard],   },
	{ path: 'home', component: HomeComponent, canActivate: [AuthGuard],  },
 	{ path: 'contact', loadChildren: './contact/contact.module#ContactModule', canActivate: [AuthGuard], },
 	{ path: 'admin', loadChildren: './admin/admin.module#AdminModule', canActivate: [AuthGuard],  },
 	{ path: 'expertise', loadChildren: './expertise/expertise.module#ExpertiseModule', canActivate: [AuthGuard],  },
 	{ path: 'compta', loadChildren: './compta/compta.module#ComptaModule', canActivate: [AuthGuard],  },
 	{ path: 'to-invoice', loadChildren: './to-invoice/to-invoice.module#ToInvoiceModule', canActivate: [AuthGuard],  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
